export default __webpack_public_path__ + "static/media/newLogo.d434ce3d.svg";